import { render, staticRenderFns } from "./FiltroGeralLoja.vue?vue&type=template&id=6f5db228"
import script from "./FiltroGeralLoja.vue?vue&type=script&lang=js"
export * from "./FiltroGeralLoja.vue?vue&type=script&lang=js"
import style0 from "./FiltroGeralLoja.vue?vue&type=style&index=0&id=6f5db228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports